export default __webpack_public_path__ + "static/media/a1.a88a9d87.JPG";